(function () {
    "use strict";
    angular.module("app.common").directive("search", search);

    function search() {
        var directive = {
            controller: [
                "$scope", "$rootScope", "parcelClientService", "searchEngine", "notifierSvc", "searchParserService", "$timeout", "$window", "addressAPI", "provinceListService", "$translate", "bolgeselDataService", "geoApi", "$state", "comparablesApi",
                controller,
            ],
            templateUrl: "/app/common/search.directive.html",
            restrict: "EA",
            scope: {
                actionType: '<',
                searchClass: '<',
                isLanding: '<'
            }
        };

        return directive;

        function controller($scope, $rootScope, parcelClientService, searchEngine, notifierSvc, searchParserService, $timeout, $window, addressAPI, provinceListService, $translate, bolgeselDataService, geoApi, $state, comparablesApi) {

            $scope.randomId = window.makeid(5);

            $scope.bindAutoComplete = function () {
                $rootScope.initAutoComplete('#' + $scope.randomId, '#' + $scope.randomId + '-btn');
            };

            $scope.initCities = function () {
                $scope.TKGMAddress.cityLoaded = false;
                $scope.TKGMAddress.cities = [];
                addressAPI.getCities().$promise.then(response => $scope.TKGMAddress.cities = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.cityLoaded = true);
            };

            $scope.cityTKGMChanged = function () {
                $scope.TKGMAddress.countyLoaded = false;
                $scope.TKGMAddress.counties = [];
                addressAPI.getCounties({ cityId: $scope.TKGMAddress.city }).$promise.then(response => $scope.TKGMAddress.counties = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.countyLoaded = true);
            };

            $scope.countyTKGMChanged = function () {
                $scope.TKGMAddress.districtLoaded = false;
                $scope.TKGMAddress.districts = [];
                addressAPI.getDistricts({ countyId: $scope.TKGMAddress.county }).$promise.then(response => $scope.TKGMAddress.districts = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.districtLoaded = true);
            };

            $scope.districtChanged = function () {
                $scope.TKGMAddress.streetLoaded = false;
                $scope.TKGMAddress.streets = [];
                addressAPI.getStreets({ districtId: $scope.TKGMAddress.district }).$promise.then(response => $scope.TKGMAddress.streets = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.streetLoaded = true);
            };

            $scope.streetChanged = function () {
                $scope.TKGMAddress.buildingLoaded = false;
                $scope.TKGMAddress.buildings = [];
                addressAPI.getBuildings({ streetId: $scope.TKGMAddress.street }).$promise.then(response => $scope.TKGMAddress.buildings = response
                    , err => { console.log(err); })
                    .finally(() => $scope.TKGMAddress.buildingLoaded = true);
            };

            $scope.TKGMAddress = {
                cities: [],
                counties: [],
                districts: [],
                neighborhoods: false,
                streets: [],
                buildings: false,
                loading: false,
                error: false,
                cityLoaded: false,
                countyLoaded: false,
                districtLoaded: false,
                neighborhoodLoaded: false,
                streetLoaded: false,
                buildingLoaded: false
            };

            $scope.searchterms = {
                cities: [],
                counties: [],
                city_loaded: false,
                county_loaded: false,
                districts: [],
                district_loaded: false,
                loading: false,
                error: false,
                coordinate: "",
                id: "",
                listing: "",
                listingNo: "",
                zemin: "",
                city: window.selectedCity,
                country: $rootScope.country
            };

            $scope.cityChanged = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.city_loaded = false;
                $scope.searchterms.county_loaded = false;
                $scope.searchterms.district_loaded = false;
                if ($scope.searchterms.city_parcel) {
                    $scope.searchterms.loading = true;
                    parcelClientService.getCounties($scope.searchterms.city_parcel).then(
                        function (result) {
                            $scope.searchterms.loading = false;
                            $scope.searchterms.counties = result.data.features;
                            $scope.searchterms.county_loaded = true;
                            $scope.searchterms.district_loaded = false;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    );
                }
            };

            $scope.countyChanged = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.district_loaded = false;
                if ($scope.searchterms.county && $scope.searchterms.county_loaded) {
                    $scope.searchterms.loading = true;
                    parcelClientService.getNeighborhoods($scope.searchterms.county).then(
                        function (result) {
                            $scope.searchterms.loading = false;
                            $scope.searchterms.districts = result.data.features;
                            $scope.searchterms.county_loaded = true;
                            $scope.searchterms.district_loaded = true;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    );
                }
            };
            var searchCoordinate = function () {
                searchEngine.searchCoordinate($scope.searchterms.coordinate);
                searchParserService.parseSearch(true, null, null, $scope.isLanding);
            };

            var searchId = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchUrl($scope.searchterms.listing).then(function (result) {
                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;
                    notifierSvc.remove();
                    notifierSvc.show({
                        message: $translate.instant('comparable_acquired'),
                        type: "success",
                    });
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);

                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var searchListingNo = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;

                comparablesApi.detail({ EndeksaId: $scope.searchterms.listingNo, captchaTokenCustom: $window.ecSec() }).$promise.then(function (result) {
                    $scope.searchterms.loading = false;
                    if (result && result.URL) {
                        if (result.ListingActive === false && result.Valuation) {
                            $scope.searchterms.error = true;
                            return;
                        }
                        var propertyName = result.URL.replace(/^\//, '');
                        $state.go('property', {
                            name: propertyName,
                            langcode: $translate.use()
                        });
                    } else {
                        $scope.searchterms.error = true;
                    }
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var searchAddressCode = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchAddressCode($scope.searchterms.id).then(function (result) {

                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            $scope.parcelChanged = parcelChanged;

            var searchTitleNo = function () {
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                searchEngine.searchTitleNo($scope.searchterms.zemin).then(function (result) {

                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;

                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;
                });
            };

            var parcelChanged = function () {
                // Validate that required fields (city, county, district) are selected before making the query
                if (!$scope.searchterms.city_parcel || !$scope.searchterms.county || !$scope.searchterms.district) {
                    return;
                }

                $scope.parcelHandler = true;
                $scope.searchterms.error = false;
                $scope.searchterms.loading = true;
                if (!$scope.searchterms.ada)
                    $scope.searchterms.ada = 0;
                searchEngine.searchParcel($scope.searchterms.district, $scope.searchterms.ada, $scope.searchterms.parsel).then(function (result) {
                    $scope.searchterms.error = false;
                    $scope.searchterms.loading = false;

                    $scope.searchterms.city_loaded = true;
                    $scope.searchterms.county_loaded = true;
                    $scope.searchterms.district_loaded = true;

                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                }, function () {
                    $scope.searchterms.error = true;
                    $scope.searchterms.loading = false;

                    $scope.searchterms.city_loaded = true;
                    $scope.searchterms.county_loaded = true;
                    $scope.searchterms.district_loaded = true;
                });
            };

            var geoap;
            var lastKnownCity;

            var countryCityChanged = function (city) {
                if (lastKnownCity === $scope.searchterms.city) {
                    $rootScope.selectedMethod = 1;
                } else {
                    lastKnownCity = $scope.searchterms.city;
                }
                $scope.searchterms.error = false;
                $scope.searchterms.loading = false;

                $scope.searchterms.city = city || $scope.searchterms.city;

                if ($scope.isLanding) {
                    if (geoap)
                        geoap.$cancelRequest();
                    const cityObj = $scope.searchterms.cities.find(m => $rootScope.normalizeAddress(m.CityName) === $scope.searchterms.city);
                    if (cityObj) {
                        geoap = geoApi.get({
                            cityId: cityObj.CityId,
                            countryId: $scope.searchterms.country,
                            level: 1
                        });
                        geoap.$promise.then(
                            function (resa) {
                                var geo = L.geoJson(resa);
                                var bounds = geo.getBounds();
                                var lbounds = {
                                    northEast: {
                                        lat: bounds._northEast.lat,
                                        lng: bounds._northEast.lng,
                                    },
                                    southWest: {
                                        lat: bounds._southWest.lat,
                                        lng: bounds._southWest.lng,
                                    },
                                    // name: resa.features[0].properties.City
                                };
                                bolgeselDataService.country = normalizeAddress(resa.features[0].properties.Country);
                                bolgeselDataService.cityBounds = lbounds;
                            },
                            function (result) {
                                if (result.xhrStatus !== 'abort')
                                    console.log(result);
                            }
                        );
                    }
                }
                searchParserService.useCity($scope.isLanding, $scope.searchterms.city, $scope.actionType);

            };
            $scope.countryCityChanged = countryCityChanged;


            var countryChanged = function (country) {
                if (country === undefined && $rootScope.country) {
                    country = $rootScope.country === 'espana' ? 2 : $rootScope.country === 'portugal' ? 3 : $rootScope.country === 'turkiye' ? 1 : 0;
                }
                $scope.searchterms.error = false;
                $scope.searchterms.loading = false;
                $scope.searchterms.country = country;
                $scope.searchterms.city_loaded = false;
                $rootScope.country = country == 2 ? 'espana' : country == 3 ? 'portugal' : country == 1 ? 'turkiye' : 'world';

                if (geoap)
                    geoap.$cancelRequest();

                if (country > 0) {
                    geoap = geoApi.get({
                        countryId: country,
                        level: 9
                    });
                    geoap.$promise.then(
                        function (resa) {
                            var geo = L.geoJson(resa);
                            var bounds = geo.getBounds();
                            var lbounds = {
                                northEast: {
                                    lat: bounds._northEast.lat,
                                    lng: bounds._northEast.lng,
                                },
                                southWest: {
                                    lat: bounds._southWest.lat,
                                    lng: bounds._southWest.lng,
                                },
                                // name: resa.features[0].properties.City
                            };
                            bolgeselDataService.country = normalizeAddress(resa.features[0].properties.Country);
                            bolgeselDataService.cityBounds = lbounds;
                        },
                        function (result) {
                            if (result.xhrStatus !== 'abort')
                                console.log(result);
                        }
                    );
                    $scope.searchterms.loading = true;
                    provinceListService.getProvinces(country).then(
                        function (result) {
                            $rootScope.cities = result.List;
                            $rootScope.cityLimit = $rootScope.country === 'espana' ? 9 : $rootScope.country === 'portugal' ? 3 : 14;

                            $scope.searchterms.loading = false;
                            $scope.searchterms.cities = [{ CityName: $translate.instant('rg_city'), CityId: 0 }];
                            result.List.forEach(function (item) {
                                $scope.searchterms.cities.push(item);
                            });
                            $scope.searchterms.city_loaded = true;
                            $scope.searchterms.county_loaded = $scope.parcelHandler || false;
                            $scope.searchterms.district_loaded = $scope.parcelHandler || false;
                        },
                        function () {
                            $scope.searchterms.error = false;
                        }
                    ).finally(() => $scope.parcelHandler = false);
                }
            };
            $scope.countryChanged = countryChanged;

            countryChanged();

            $scope.useLocation = function () {
                $scope.searchterms.error = false;
                // $scope.searchterms.address = $window.lang === 'tr' ? "Yükleniyor..." : "Loading...";
                $scope.searchterms.loading = false;
                searchParserService.useLocation($scope.isLanding, $scope.actionType);
            };
            $rootScope.selectedMethod = $scope.isLanding ? 0 : $rootScope.selectedMethod ? $rootScope.selectedMethod : 0;

            $scope.saveSelectionTop = function () {
                $scope.searchterms.address = "";
                $scope.searchterms.coordinate = "";
                $scope.searchterms.id = "";
                $scope.searchterms.listing = "";
                $scope.searchterms.listingNo = "";
                $scope.searchterms.zemin = "";
                $scope.searchterms.error = false;
            };

            // $rootScope.$watch('address', function (val) {
            //   $scope.searchterms.address = val;
            // });


            $rootScope.$on("link_defined", function (event, data) {
                if ($state.current.name.indexOf('valuation') === -1) {
                    $rootScope.selectedMethod = 5;
                    $scope.searchterms.listing = data.query;
                    $window.lastLevel = 0;
                    searchId();
                }
            });

            $rootScope.$on("selected_city", function (event, data) {
                if (data.city)
                    $scope.searchterms.city = data.city;
                $scope.searchterms.country = data.country === 'espana' ? 2 : data.country === 'portugal' ? 3 : data.country === 'turkiye' ? 1 : 0;
                $rootScope.selectedMethod = ($rootScope.selectedMethod === 1 || $rootScope.selectedMethod === 0) ? ((typeof data.level === "undefined" || data.level === 10 || data.level === 9) ? 0 : 1) : $rootScope.selectedMethod;

                if (!data.city && data.country && data.country !== 'world' && $scope.searchterms.country !== data.country)
                    countryChanged();
            });

            $rootScope.$on('input_cleaned', function () {
                $scope.searchterms.address = null;
                $scope.searchterms.listing = null;
                $scope.searchterms.id = null;
                $scope.searchterms.coordinate = null;
                $scope.searchterms.zemin = null;
                $scope.searchterms.listingNo = null;
                $scope.searchterms.loading = false;
            });

            $scope.focusIn = function () {
                // $timeout(function () {
                $rootScope.searchFocused = 1;
                // }, 100);
            };

            $scope.focusOut = function () {
                $timeout(function () {
                    $rootScope.searchFocused = 0;
                }, 300);
            };

            $rootScope.parserSearchfromInputTop = function (section) {
                if (+section === 0) {
                    $window.lastLevel = 0;
                    countryCityChanged();
                } else if (+section === 1) {
                    searchParserService.parseSearch(true, null, null, $scope.isLanding);
                } else if (+section === 2) {
                    $window.lastLevel = 0;
                    parcelChanged();
                } else if (+section === 3) {
                    $window.lastLevel = 0;
                    searchCoordinate();
                } else if (+section === 4) {
                    $window.lastLevel = 0;
                    searchAddressCode();
                } else if (+section === 5) {
                    $window.lastLevel = 0;
                    searchId();
                } else if (+section === 6) {
                    $window.lastLevel = 0;
                    searchTitleNo();
                } else if (+section === 7) {

                } else if (+section === 8) {
                    $window.lastLevel = 0;
                    searchListingNo();
                }
            };

            $scope.parserSearchfromInputTop = $rootScope.parserSearchfromInputTop;

            $scope.triggerTooltip = function () {
                const $tooltipEl = $('#search-error-tooltip');

                const hideTooltip = function () {
                    $tooltipEl.tooltip('hide');
                    $(document).off('click', hideTooltip);
                };

                $timeout(function () {
                    // Clean up any existing tooltips
                    $tooltipEl.tooltip('hide').tooltip('destroy');
                    $tooltipEl.removeData('bs.tooltip');
                    $('.tooltip').remove();

                    // Initialize a new tooltip after cleanup
                    $timeout(function () {
                        $tooltipEl.tooltip({ trigger: 'manual' }).tooltip('show');

                        // Hide tooltip when clicking outside
                        $(document).on('click', hideTooltip);

                        // Auto-hide tooltip after 4 seconds
                        $timeout(hideTooltip, 4000);
                    }, 50);
                }, 100);
            };
        }


    }
})();
